<template>
    <div class="link-auto-table-filter">
        <link-select v-model="currentSearchField"
                     :size="size"
                     placeholder="搜索字段..."
                     :width="option.searchSelectWidth"
                     shape="none"
                     type="line"
                     color="info"
                     :data="p_filterOptions"
                     label-key="name" val-key="field">
        </link-select>
        <link-button
                class="link-auto-table-filter-input"
                type="line"
                node="div"
                :color="color"
                :size="size"
                :shade-on-click="false"
                :click-effect="false"
                :no-padding="true">
            <link-icon icon="link-icon-search" v-if="option.searchBarSearchIcon"/>
            <keep-alive>
                <component
                        ref="filter"
                        :is="`link-auto-table-filter-${currentFilterType}`"
                        :field="currentOption.field"
                        :lov="currentOption.lov"
                        :option="currentOption"
                        :filter-value="filterValue"
                        type="none"
                        @confirm="handleConfirm"/>
            </keep-alive>
        </link-button>
        <link-button class="link-auto-table-filter-search-button" @click.stop="handleClickSearch" color="primary" label="查询" v-if="!!option.searchBarSearchButton"/>
        <link-auto-table-filter-store :option="option" v-if="!!option.storeFilterButton"/>
    </div>
</template>

<script>
    import LinkAutoTableFilterStore from "./link-auto-table-filter-store";

    export default {
        name: 'link-auto-table-filter',
        components: {LinkAutoTableFilterStore},
        props: {
            option: {},
            filterOptions: {},
            searchField: {},

            type: {type: String, default: 'fill'},
            size: {type: String, default: 'large'},
            color: {type: String, default: 'primary'},
            placeholder: {type: String, default: '搜索关键字...'}
        },
        watch: {
            filterOptions: {
                immediate: true,
                handler(val) {
                    if (!this.option.searchField && Boolean(val) && val.length > 0) this.option.searchField = val[0].field;
                }
            },
            searchField(val) {
                this.currentSearchField !== val && (this.currentSearchField = val);
            },
            currentSearchField(val) {
                this.$emit('update:searchField', val);
            }
        },
        data() {
            return {
                currentSearchField: this.searchField,
                filterValue: {
                    value: null,
                    lov: null,
                    startValue: null,
                    endValue: null,
                    startNumber: null,
                    endNumber: null
                }
            };
        },
        computed: {
            p_filterOptions() {
                if (!this.filterOptions || this.filterOptions.length === 0) return
                // console.log(this.filterOptions)
                if (!this.option.defaultSearchIdField) {
                    return this.filterOptions
                }
                const idCol = this.$lv.$utils.findOne(this.filterOptions, item => !!item.name && item.name.toLowerCase() === 'id')
                if (!!idCol)
                    return this.filterOptions
                else
                    return [...this.filterOptions, {field: 'id', name: 'Id', lnkType: 'normal'}]
            },
            currentOption() {
                return !this.option || !this.p_filterOptions ? {} : this.p_filterOptions.reduce((ret, item) => item.field === this.currentSearchField ? item : ret, {});
            },
            currentFilterType() {
                if (Boolean(this.currentOption.lov)) return 'lov';
                switch (this.currentOption.lnkType) {
                    case 'date':
                        return 'datepicker';
                    case 'time':
                        return 'timepicker';
                    case 'number':
                        return 'input-number';
                    default:
                        return 'input';
                }
            },
        },
        methods: {
            clearValue() {
                Object.assign(this.filterValue, {startValue: null, endValue: null, startNumber: null, endNumber: null, value: null, lov: null});
                this.option.singleFiltersRaw = null
            },
            handleClickSearch() {
                this.handleConfirm({filtersRaw: this.$refs.filter.getValue(), type: this.currentFilterType});
            },
            async handleConfirm({filtersRaw, type}) {
                if (!!this.currentOption.field) {
                    this.option.singleFiltersRaw = filtersRaw;
                    this.option.searchAllFieldFlag = false
                    this.$emit('confirm');
                    switch (type) {
                        case 'lov':
                            Object.assign(this.filterValue, {startValue: null, endValue: null, startNumber: null, endNumber: null, value: null});
                            break;
                        case 'date':
                            Object.assign(this.filterValue, {lov: null, startNumber: null, endNumber: null, value: null});
                            break;
                        case 'time':
                            Object.assign(this.filterValue, {lov: null, startNumber: null, endNumber: null, value: null});
                            break;
                        case 'number':
                            Object.assign(this.filterValue, {lov: null, startValue: null, endValue: null, value: null});
                            break;
                        case 'input':
                            Object.assign(this.filterValue, {lov: null, startValue: null, endValue: null, startNumber: null, endNumber: null});
                            break;
                    }
                } else {
                    const searchValue = this.filterValue.value
                    if (!searchValue) {
                        this.option.singleFiltersRaw = null
                        this.option.searchAllFieldFlag = false
                    } else {
                        console.log('全字段查询', searchValue)
                        const singleFiltersRaw = []
                        for (let i = 0; i < this.filterOptions.length; i++) {
                            const opt = this.filterOptions[i];
                            if (opt.isLink && opt.type === 'picklist') {
                                singleFiltersRaw.push({property: opt.field, value: searchValue, operator: 'LIKE'})
                            } else switch (opt.lnkType) {
                                case 'normal':
                                case 'number':
                                    singleFiltersRaw.push({property: opt.field, value: searchValue, operator: 'LIKE'})
                                    break;
                                case 'lov':
                                    let lovs = await this.$lov.getLovByType(opt.lov)
                                    if (!!lovs && lovs.length > 0) {
                                        lovs.filter(item => item.name.indexOf(searchValue) > -1).forEach(item => {
                                            singleFiltersRaw.push({
                                                property: opt.field,
                                                value: item.val,
                                                operator: '=',
                                            })
                                        })
                                    }
                                    break
                            }
                        }
                        this.option.singleFiltersRaw = singleFiltersRaw
                        this.option.searchAllFieldFlag = true
                    }
                    this.$emit('confirm');
                }
            },
        }
    };
</script>

<style lang="scss">
    @include themeify {
        .link-auto-table-filter {
            display: flex;
            box-sizing: border-box;
            justify-content: flex-start;
            background-color: white;

            .link-segment {
                height: 32px !important;
                width: 1px !important;
                background: $color-info;
            }

            .link-auto-table-filter-search-button {
                position: relative;
                left: -1px;
            }

            .link-auto-table-filter-input {
                padding-left: 8px !important;
                margin-left: -2px;

                .link-input {
                    border-color: transparent !important;
                }
            }
        }
    }
</style>
